import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useTranslation } from 'react-i18next';

const navLinkClass = "flex items-center px-3 py-2.5 rounded-xl text-brand-800 hover:bg-brand-50 hover:text-brand-600 transition-colors text-sm font-medium group";

const ProgramSidebar: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();

  return (
    <Sidebar>
      <li>
        <Link to="/" className={navLinkClass}>
          <span>{t("programs")}</span>
        </Link>
      </li>
      <li>
        <Link to={`/Dashboard/Program/${id}`} className={navLinkClass}>
          <span>{t("dashboard")}</span>
        </Link>
      </li>
      <li>
        <Link to={`/Dashboard/Program/${id}/Customers/`} className={navLinkClass}>
          <span>{t("users")}</span>
        </Link>
      </li>
      <li>
        <Link to={`/Dashboard/Program/${id}/SendNotification`} className={navLinkClass}>
          <span>{t("sendNotification")}</span>
        </Link>
      </li>
      <li>
        <Link to={`/Dashboard/Program/${id}/SubUsers`} className={navLinkClass}>
          <span>{t("subUsers")}</span>
        </Link>
      </li>
      <li>
        <Link to={`/Dashboard/Program/${id}/Edit`} className={navLinkClass}>
          <span>{t("editPassTemplate")}</span>
        </Link>
      </li>
    </Sidebar>
  );
};

export default ProgramSidebar;
